import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import * as XLSX from "xlsx";
import { useTranslation } from "react-i18next";

const API_URL = "https://crm-mqtt-718408119422.asia-east1.run.app/api/v1/product/list";
const API_KEY = "57b2a9ba-4428-48e4-b137-f8337b68595e";
const APPSMITH_PRODUCTS_URL =
  "https://app.appsmith.com/app/untitled-application-1/page1-68795b71e2b110151a8f4da3?embed=true&hide_navigation_bar=true&reload=${Date.now()}";

const convertToSheetData = (data = []) => {
  if (!data.length) return [];

  const headers = [
    "ProductCode",
    "Barcode",
    "ProductName",
    "ProductSpecs",
    "VenderCode",
    "VenderName",
    "Brand",
    "MovieOrPortrait",
    "Nature",
    "ProductSeries",
    "CategoryName",
    "Price",
    "NotePrivate",
    "PVideos",
    "CostPrice",
    "IsEnable",
    "PackagingSize",
    "CapsuleSize",
    "ValidUntil",
    "MallListing",
    "WAttributes",
    "PBrand",
    "PAttributes",
    "TagList",
    "Display_Name",
    "NotePublic",
    "Date_Creation",
    "Date_Modification",
  ];

  const rows = data.map((item) => {
    const opts = item.array_options || {};
    const retailPrice = parseFloat(item.price) || 0;
    const costPrice = Math.round(retailPrice * 0.8);

    return [
      item.ref ? String(item.ref) : "",
      item.barcode ? String(item.barcode) : "",
      item.label || "",
      opts.options_product_specs || "",
      opts.options_vender_code || "",
      opts.options_vender_name || "",
      opts.options_brand || "",
      opts.options_movie_or_portrait || "",
      opts.options_nature || "",
      opts.options_product_series || "",
      opts.options_category_name || "",
      item.price || "",
      item.note_private || "",
      opts.options_p_videos || "",
      costPrice,
      item.status === "1" ? "Y" : "N",
      opts.options_packaging_size || "",
      opts.options_capsule_size || "",
      opts.options_valid_until || "",
      opts.options_mall_listing || "",
      opts.options_w_attributes || "",
      opts.options_p_brand || "",
      opts.options_p_attributes || "",
      opts.options_tag_list || "",
      opts.options_display_name || "",
      item.note_public || "",
      item.date_creation || "",
      item.date_modification || "",
    ];
  });

  return [headers, ...rows];
};

function ProductsBK() {
  const { t } = useTranslation("common");
  const downloadExcel = async () => {
    try {
      const res = await fetch(API_URL, {
        headers: {
          "Mdm-Auth": API_KEY,
        },
      });
      const json = await res.json();
      if (!json.data) {
        alert("API 無資料");
        return;
      }

      const sheetData = convertToSheetData(json.data);
      if (!sheetData.length) {
        alert("無可匯出的資料");
        return;
      }

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const range = XLSX.utils.decode_range(worksheet["!ref"]);

      for (let row = 1; row <= range.e.r; row += 1) {
        const productCodeCell = worksheet[XLSX.utils.encode_cell({ r: row, c: 0 })];
        const barcodeCell = worksheet[XLSX.utils.encode_cell({ r: row, c: 1 })];
        if (productCodeCell) productCodeCell.t = "s";
        if (barcodeCell) barcodeCell.t = "s";
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Products");
      XLSX.writeFile(workbook, "products.xlsx");
    } catch (error) {
      console.error(error);
      alert("下載失敗");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  {t("pageTitles.products")}
                </MDTypography>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={downloadExcel}
                  sx={{
                    backgroundColor: "#FF9800",
                    color: "#FFFFFF",
                    "&:hover": { backgroundColor: "#FB8C00" },
                  }}
                >
                  {t("actions.exportProductSheet")}
                </Button>
              </MDBox>

              <MDBox pt={3} px={0} width="100%">
                <iframe
                  src={APPSMITH_PRODUCTS_URL}
                  width="100%"
                  height="800px"
                  frameBorder="0"
                  title="Appsmith Products"
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default ProductsBK;
